import { NormalizationUtilities } from "../storeTypes";
import { PlayerState } from "../rootReducer";
import { getEmptyTraversalObject } from "../normalizationUtils";
import { themesSchema } from "../normalizationSchemas";

export const themeNormalization: NormalizationUtilities = {
  schema: themesSchema,
  traverseFunction: (themeId: string, state: PlayerState) => {
    const result = getEmptyTraversalObject();
    result.themes.add(themeId);
    return result;
  },
};
